export default __webpack_public_path__ + "static/media/mastercard.d68df551.svg";